/*SYSTEM IMPORTS*/
import React from 'react'

import c from 'classnames'

import Link from 'components/Link'

import './style'
import './media'

const Btn = ({ to = false, type = "btn", ...props }) => (
    to === false ?
        <button
            id={props.id}
            className={c(type, { "btn_border": props.border, "btn_big-padding": props.btnBigPadding  }, props.className)}
            disabled={props.disabled}
            onClick={props.onClick}
            type={props.btn_type}
        >
            {props.image}
            <span className="text">
                {props.children}
            </span>
            {/* {props.image != false && !props.rightImage && props.image}
            {props.image != false && props.rightImage && props.image} */}
        </button>
        :
        <Link
            to={to}
            target={props.target}
            className={c(type, { "link_active": props.active }, props.className)}
            onClick={props.onClick}
        >
            {props.image}
            <span className="text">
                {props.children}
            </span>
            {/* {props.image != false && !props.rightImage && props.image}
            {props.image != false && props.rightImage && props.image} */}
        </Link>
)

export default Btn